<div class="page-selection-container">
  <label class="control-label" for="page">{{locale.LABEL_PAGE}}</label>
  <select class="app-select form-control"
          name="page" id="page" [(ngModel)]="bindWidgetsVariablesUtilsService.selectedPage"
          [ngModelOptions]="{updateOn: 'change'}"
          (change)="bindWidgetsVariablesUtilsService.onPageChange()">
    <option *ngFor="let page of bindWidgetsVariablesUtilsService.pages" [ngValue]="page">{{page.name}}</option>
  </select>
</div>
